/**
 * Provides global window object as a module in order to
 * make it injectable and possible to mock in unit tests.
 */
export default window;